import { jsx } from "react/jsx-runtime";
import UnfoldMoreIcon from "@mui/icons-material/UnfoldMore";
import { validateTidalLicense } from "../../base/index.js";
function UnfoldMore(props) {
  return /* @__PURE__ */ jsx(
    UnfoldMoreIcon,
    {
      "data-testid": "UnfoldMore",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "UnfoldMore",
      "data-tidal-icon-meta": "common,navigation"
    }
  );
}
UnfoldMore.tidalIconMeta = {
  categories: "common,navigation",
  name: "UnfoldMore"
};
validateTidalLicense();
export {
  UnfoldMore
};
//# sourceMappingURL=UnfoldMore.js.map
